import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { appLogger } from "../../../utils";
import MobileGeneralPreview from "./mobileGeneral";
import MobileFeedbackCategory from "./mobileFeedbackCategory";
import MobileFeedbackRating from "./mobileFeedbackRating";
import MobileFeedbackSuccess from "./mobileFeedbackSuccess";
import MobileFeedbackAttachment from "./mobileFeedbackAttachment";
import MobileBugPreview from "./mobileBugPreview";
import MobileFeatureRequest from "./mobileFeatureRequest";
import MobileWidgetPreview from "./mobileWidgetPreview";
import { FEEDBACK_FLOW_DYNAMIC } from "../../../model";
import MobileMultiFeedback from "./mobileMultiFeedbackPreview";

// import MobileGeneralPreview from "./MobileAgentPreview/MobileGeneralPreview";
// import MobileFeedbackPreview from "./MobileAgentPreview/MobileFeedbackPreview";
// import MobileFeedbackRatingPreview from "./MobileAgentPreview/MobileFeedbackRatingPreview";

const MobilePreview = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "GeneralSettingsAgentPreview",
      component: "add-product",
      fileName: "GeneralSettingsAgentPreview.tsx",
      props: props,
    },
  });
  const { productParams, widgetInfo } = props;
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [PreviewZoom, setPreviewZoom] = React.useState<any>("zoomout");
  const [selectedCategory, setSelectedCategory] = React.useState("");

  const [Changeradiocat, setChangeradiocat] = React.useState("");

  const handleSelectCategory = (e: any) => {
    const { value } = e.target;
    setSelectedCategory(value);
  };

  const onChangeradiocat = (event: any) => {
    setChangeradiocat(event.target.value);
  };

  const freqfullscreenchanged = (event: any) => {
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If not, the value
    // of the property is null.
    if (document.fullscreenElement) {
      setPreviewZoom("zoomin");
    } else {
      setPreviewZoom("zoomout");
    }
  };

  const el: any = document.getElementById("genset-fullscreen-div");
  const tt: any = document.getElementById("genset-toggle-fullscreen");

  if (el != null) {
    el.addEventListener("fullscreenchange", freqfullscreenchanged);
    // or
    el.onfreqfullscreenchange = freqfullscreenchanged;
  }

  if (tt != null) {
    // When the toggle button is clicked, enter/exit fullscreen

    tt.addEventListener("click", (event: any) => {
      if (document.fullscreenElement) {
        // exitFullscreen is only available on the Document object.
        document.exitFullscreen();
      } else {
        el.requestFullscreen();
      }
    });
  }

  return (
    <Grid className="mobile-preview-wrap">
      <Typography ref={props.generalPreviewRef}></Typography>
      <MobileGeneralPreview productParams={productParams} />

      {/* <MobileFeedbackPreview
        productParams={productParams}
        selectedCategory={selectedCategory}
        handleSelectCategory={handleSelectCategory}
      />
      <MobileFeedbackRatingPreview
        productParams={productParams}
        selectedCategory={selectedCategory}
      /> */}

      {/* ***********Feeback Form ********************** */}
      <Typography ref={props.feedbackPreviewRef}></Typography>
      {productParams.productParams.products[0]?.feedbackAgentSettings
        .feedbackSettings.type === FEEDBACK_FLOW_DYNAMIC ? (
        <>
          <MobileFeedbackCategory
            productParams={productParams}
            onChangeradiocat={onChangeradiocat}
          />

          <MobileFeedbackRating productParams={productParams} />
          <MobileFeedbackAttachment
            productParams={productParams}
            Changeradiocat={Changeradiocat}
          />

          <MobileFeedbackSuccess productParams={productParams} />
        </>
      ) : (
        <>
          <MobileMultiFeedback productParams={productParams} />
          <MobileFeedbackSuccess productParams={productParams} />
        </>
      )}
      {/* ***********Feeback Form ********************** */}
      {/* ***********Bug Form ********************** */}
      <Typography ref={props.bugPreviewRef}></Typography>
      <MobileBugPreview productParams={productParams} />
      {/* ***********Bug Form ********************** */}
      {/* ***********Feature Request Form ********************** */}
      <Typography ref={props.featurePreviewRef}></Typography>
      <MobileFeatureRequest productParams={productParams} />
      {/* ***********Feature Request Form ********************** */}
      {/* **************************Widget Preview**************************************/}
      <Typography ref={props.widgetCodePreviewRef}></Typography>
      <MobileWidgetPreview
        widgetInfo={widgetInfo}
        productParams={productParams}
      />
      {/* ************************************************************************************ */}
    </Grid>
  );
};

export default MobilePreview;
